module.exports = __webpack_public_path__ + "img/img_5.d92c3371.jpg";